// What the screen calls the selected supplier (2026-10-02, PRIME DENTAL shown as "Curaden").
// The supplier CODE stays the key everywhere; its display name (suppliers.fname, the `text` of
// each user_supplier_access row) is shown only when it is really a different name — ignoring case,
// spaces and punctuation — so "ALETTES" / "Alettes" keeps reading ALETTES exactly as before.
// docs/michael/supplier-rename/TASK-prime-dental-to-curaden.md
const norm = (s) => String(s || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase()

export const supplierLabel = (code, access) => {
  if (!code) return code
  const row = (access || []).find((s) => s && s.value === code)
  const name = row && row.text
  // Shown in CAPITALS everywhere (Helena 2026-10-18) — the codes already are; a display name like "Curaden" reads CURADEN.
  return String(name && norm(name) !== norm(code) ? name : code).toUpperCase()
}

// Supplier codes sorted by what the screen shows (2026-10-16, Helena: Curaden sits after CLEAR_WORLD, not under P).
export const sortByLabel = (codes, access) =>
  [...(codes || [])].sort((a, b) => String(supplierLabel(a, access) || "").localeCompare(String(supplierLabel(b, access) || ""), undefined, { sensitivity: "base" }))
